/* eslint-disable import/no-relative-packages */
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useNavigate from '../../hooks/useNavigate';
import { WebLink } from '../../theme/colors';
import { ExternalLinkIcon } from '../Icons';
import { useSettingsPageRedirection } from '../Settings/useSettingsPageRedirection';
import BaseTypography, { BaseTypographyProps } from '../Text/BaseTypography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: WebLink,
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
  }),
);

interface LinkProps extends BaseTypographyProps {
  text: string;
  toPath: string;
  hasSettingsDestination?: boolean;
  suffixIcon?: JSX.Element;
  openExternally?: boolean;
}
export const LinkButton: React.FC<LinkProps> = ({
  toPath,
  hasSettingsDestination = false,
  text,
  suffixIcon = <ExternalLinkIcon style={{ fontSize: 12 }} />,
  openExternally = false,
  ...others
}) => {
  const classes = useStyles();
  const { navigate } = useNavigate();
  const { goToSettings } = useSettingsPageRedirection(true, toPath);

  const handleLinkClicked = () => {
    if (!hasSettingsDestination) {
      if (openExternally) {
        window.open(toPath, '_blank', 'noopener');
        return;
      }
      navigate(toPath);
    }
    goToSettings();
  };

  return (
    <BaseTypography
      className={classes.root}
      onClick={handleLinkClicked}
      component="span"
      {...others}
    >
      {text}
      {suffixIcon}
    </BaseTypography>
  );
};
